export const sectionsIds = {
  events: 'events',
  speakers: 'speakers',
  schedule: 'schedule',
  faqs: 'faqs'
};

export const headerSections = [
  { name: 'Events', id: sectionsIds.events },
  { name: 'Speakers', id: sectionsIds.speakers },
  { name: 'Schedule', id: sectionsIds.schedule }
];

export const allSections = [
  ...headerSections,
  { name: 'FAQs', id: sectionsIds.faqs }
];

export const getOffsetTop = (elem) => {
  let offsetTop = 0;
  let currentElement = elem;
  do {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(currentElement.offsetTop)) {
      offsetTop += currentElement.offsetTop;
    }
    currentElement = currentElement.offsetParent;
  } while (currentElement);
  return offsetTop;
};

// align with content - (((window.innerWidth - 1136 - 24) / 2) * (window.innerHeight / window.innerWidth))
export const scrollToRef = (ref, isMobileDevice) => {
  const element = ref?.current;
  if (element) {
    window.scrollTo({
      left: 0,
      top:
        element.parentElement.offsetTop -
        (isMobileDevice
          ? 0
          : ((window.innerWidth - element.getBoundingClientRect().width) / 2) *
            (window.innerHeight / window.innerWidth)),
      behavior: 'smooth'
    });
  }
};
